/*
# Copyright ©2020-2021. Biorithm Pte Ltd. All Rights Reserved. 
# This software is the property of Biorithm Pte Ltd. 
# It must not be copied, printed, distributed, or reproduced in whole or in part
# or otherwise disclosed without prior written consent from Biorithm.
# This document may follow best coding practices for JavaScript as suggested in 
# ES2021
#
# Filename: MultiCTGView.js
# Original Author: PHAM DUY HOAN
# Date created: 15 JUL 2021
# Purpose: MultiCTGView for viewing CTG trace
# Revision History Raises (if any issues):
*/
import React, {useEffect, useState, useLayoutEffect, useRef} from "react";
import CanvasJSReact from "../static/canvasjs.react";
// import heartRateData from "./data";
import {Box} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import LogoCanvas from './logo-canvas.png'

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const TestCanvasJSChart = () => {
    const options = {
			animationEnabled: true,
			exportEnabled: true,
			theme: "light2", // "light1", "dark1", "dark2"
			title:{
				text: "Bounce Rate by Week of Year"
			},
			axisY: {
				title: "Bounce Rate",
				includeZero: false,
				suffix: "%"
			},
			axisX: {
				title: "Week of Year",
				prefix: "W",
				interval: 2
			},
			data: [{
				type: "line",
				toolTipContent: "Week {x}: {y}%",
				dataPoints: [
					{ x: 1, y: 64 },
					{ x: 2, y: 61 },
					{ x: 3, y: 64 },
					{ x: 4, y: 62 },
					{ x: 5, y: 64 },
					{ x: 6, y: 60 },
					{ x: 7, y: 58 },
					{ x: 8, y: 59 },
					{ x: 9, y: 53 },
					{ x: 10, y: 54 },
					{ x: 11, y: 61 },
					{ x: 12, y: 60 },
					{ x: 13, y: 55 },
					{ x: 14, y: 60 },
					{ x: 15, y: 56 },
					{ x: 16, y: 60 },
					{ x: 17, y: 59.5 },
					{ x: 18, y: 63 },
					{ x: 19, y: 58 },
					{ x: 20, y: 54 },
					{ x: 21, y: 59 },
					{ x: 22, y: 64 },
					{ x: 23, y: 59 }
				]
			}]
		}
    return (
		<div>
			<h1>React Line Chart</h1>
			<CanvasJSChart options = {options}
				/* onRef={ref => this.chart = ref} */
			/>
			{/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
		</div>
		);
}

const CTGGrid = () => {
    var dataPointsArray = [1835,1967,1956,1952,1952,1919,1886,1886,1883,1883,1876,1859,1859,1838,1844,1844,1838,1823,1823,1823,1850,1850,1817,1824,1824,1846,1835,1835,1838,1838,1853,1853,1853,1853,1862,1862,1858,1872,1872,1876,1874,1874,1883,1896,1896,1911,1911,1910,1913,1913,1906,1935,1935,1933,1934,1934,1936,1944,1944,1943,1948,1948,1939,1957,1957,1963,1954,1954,1954,1954,1971,1971,1971,1967,1960,1960,1970,1976,1976,1971,1962,1962,1978,1960,1960,1957,1957,1972,1966,1966,1966,1960,1960,1955,1968,1968,1970,1956,1956,1971,1972,1972,1959,1972,1972,1991,1978,1978,1967,1967,1966,1979,1979,1973,1968,1968,1979,1977,1977,1960,1970,1970,1975,1964,1964,1968,1968,1969,1960,1960,1971,1970,1970,1974,1975,1975,1967,1960,1960,1976,1974,1974,1983,1978,1978,1974,1974,1985,1982,1982,1974,1984,1984,1983,1984,1984,1992,1987,1987,1987,1987,1987,1992,1992,1987,1996,1996,1996,1992,1992,1994,1992,1992,2004,2001,2001,2004,1998,1998,1991,2005,2005,2022,2022,2005,2007,2007,2011,2012,2012,2008,2016,2016,2021,2024,2024,2005,2011,2011,2019,2019,2014,2015,2015,2014,1999,1999,2011,2013,2013,1999,2024,2024,2008,1996,1996,2027,2011,2011,2010,2010,2036,2023,2023,2028,2045,2045,2050,2051,2051,2059,2054,2054,2067,2056,2056,2047,2066,2066,2049,2049,2035,2041,2041,2013,2020,2020,2014,1998,1998,1990,1992,1992,1987,1980,1980,1979,1985,1985,1980,1980,1981,1992,1992,1974,1987,1987,1977,1981,1981,1983,1987,1987,2013,2040,2040,2083,2130,2130,2183,2183,2250,2325,2325,2423,2527,2527,2559,2559,2559,2523,2368,2368,2232,2096,2096,2004,2004,1901,1858,1858,1834,1838,1838,1831,1853,1853,1847,1845,1845,1851,1860,1860,1870,1872,1872,1891,1893,1893,1894,1894,1901,1919,1919,1917,1930,1930,1947,1925,1925,1943,1952,1952,1947,1954,1954,1951,1951,1960,1962,1962,1966,1978,1978,1979,1973,1973,1984,1978,1978,1984,1991,1991,1983,1983,1983,1999,1992,1992,1998,1998,1998,2006,2006,1999,2016,2016,2005,2038,2038,2006,2017,2017,2042,2027,2027,2031,2031,2051,2044,2044,2043,2070,2070,2062,2055,2055,2065,2056,2056,2070,2080,2080,2068,2078,2078,2077,2077,2074,2087,2087,2093,2102,2102,2091,2102,2102,2118,2114,2114,2116,2128,2128,2108,2108,2095,2108,2108,2102,2096,2096,2094,2081,2081,2074,2082,2082,2088,2059,2059,2058,2050,2050,2027,2027,2014,2009,2009,1991,1981,1981,1951,1949,1949,1932,1918,1918,1923,1893,1893,1885,1885,1894,1882,1882,1871,1890,1890,1865,1868,1868,1874,1876,1876,1887,1884,1884,1886,1888,1888,1895,1902,1902,1898,1898,1898,1906,1906,1911,1914,1914,1918,1922,1922,1918,1936,1936,1950,1937,1937,1944,1944,1955,1947,1947,1951,1984,1984,1950,1972,1972,1974,1958,1958,1982,1971,1971,1983,1974,1974,1967,1986,1986,1979,1979,1970,1986,1986,1966,1955,1955,1970,1976,1976,1972,1968,1968,1970,1969,1969,1967,1967,1998,1976,1976,1981,1994,1994,1982,1987,1987,1987,1996,1996,1983,1974,1974,1991,1991,1982,1984,1984,2004,1982,1982,1983,2009,2009,1995,1991,1991,2001,2000,2000,1991,1999,1999,2002,1988,1988,1999,1999,1979,2006,2006,2005,1983,1983,1995,1986,1986,1992,2010,2010,1993,2000,2000,1994,1994,1990,2012,2012,1989,1993,1993,1993,1986,1986,1999,1986,1986,2002,1995,1995,1995,1993,1993,2000,2000,1996,1997,1997,1995,1998,1998,1983,1997,1997,1998,1990,1990,1993,1996,1996,1982,1995,1995,2003,2003,2003,1996,1996,1993,1989,1989,2007,2008,2008,2006,2004,2004,1997,2000,2000,2012,2007,2007,2013,2013,2010,2004,2004,2010,2011,2011,2011,2015,2015,2015,2016,2016,2011,2005,2005,2014,2014,2008,1998,1998,2021,2009,2009,2007,2018,1835,1967,1956,1952,1952,1919,1886,1886,1883,1883,1876,1859,1859,1838,1844,1844,1838,1823,1823,1823,1850,1850,1817,1824,1824,1846,1835,1835,1838,1838,1853,1853,1853,1853,1862,1862,1858,1872,1872,1876,1874,1874,1883,1896,1896,1911,1911,1910,1913,1913,1906,1935,1935,1933,1934,1934,1936,1944,1944,1943,1948,1948,1939,1957,1957,1963,1954,1954,1954,1954,1971,1971,1971,1967,1960,1960,1970,1976,1976,1971,1962,1962,1978,1960,1960,1957,1957,1972,1966,1966,1966,1960,1960,1955,1968,1968,1970,1956,1956,1971,1972,1972,1959,1972,1972,1991,1978,1978,1967,1967,1966,1979,1979,1973,1968,1968,1979,1977,1977,1960,1970,1970,1975,1964,1964,1968,1968,1969,1960,1960,1971,1970,1970,1974,1975,1975,1967,1960,1960,1976,1974,1974,1983,1978,1978,1974,1974,1985,1982,1982,1974,1984,1984,1983,1984,1984,1992,1987,1987,1987,1987,1987,1992,1992,1987,1996,1996,1996,1992,1992,1994,1992,1992,2004,2001,2001,2004,1998,1998,1991,2005,2005,2022,2022,2005,2007,2007,2011,2012,2012,2008,2016,2016,2021,2024,2024,2005,2011,2011,2019,2019,2014,2015,2015,2014,1999,1999,2011,2013,2013,1999,2024,2024,2008,1996,1996,2027,2011,2011,2010,2010,2036,2023,2023,2028,2045,2045,2050,2051,2051,2059,2054,2054,2067,2056,2056,2047,2066,2066,2049,2049,2035,2041,2041,2013,2020,2020,2014,1998,1998,1990,1992,1992,1987,1980,1980,1979,1985,1985,1980,1980,1981,1992,1992,1974,1987,1987,1977,1981,1981,1983,1987,1987,2013,2040,2040,2083,2130,2130,2183,2183,2250,2325,2325,2423,2527,2527,2559,2559,2559,2523,2368,2368,2232,2096,2096,2004,2004,1901,1858,1858,1834,1838,1838,1831,1853,1853,1847,1845,1845,1851,1860,1860,1870,1872,1872,1891,1893,1893,1894,1894,1901,1919,1919,1917,1930,1930,1947,1925,1925,1943,1952,1952,1947,1954,1954,1951,1951,1960,1962,1962,1966,1978,1978,1979,1973,1973,1984,1978,1978,1984,1991,1991,1983,1983,1983,1999,1992,1992,1998,1998,1998,2006,2006,1999,2016,2016,2005,2038,2038,2006,2017,2017,2042,2027,2027,2031,2031,2051,2044,2044,2043,2070,2070,2062,2055,2055,2065,2056,2056,2070,2080,2080,2068,2078,2078,2077,2077,2074,2087,2087,2093,2102,2102,2091,2102,2102,2118,2114,2114,2116,2128,2128,2108,2108,2095,2108,2108,2102,2096,2096,2094,2081,2081,2074,2082,2082,2088,2059,2059,2058,2050,2050,2027,2027,2014,2009,2009,1991,1981,1981,1951,1949,1949,1932,1918,1918,1923,1893,1893,1885,1885,1894,1882,1882,1871,1890,1890,1865,1868,1868,1874,1876,1876,1887,1884,1884,1886,1888,1888,1895,1902,1902,1898,1898,1898,1906,1906,1911,1914,1914,1918,1922,1922,1918,1936,1936,1950,1937,1937,1944,1944,1955,1947,1947,1951,1984,1984,1950,1972,1972,1974,1958,1958,1982,1971,1971,1983,1974,1974,1967,1986,1986,1979,1979,1970,1986,1986,1966,1955,1955,1970,1976,1976,1972,1968,1968,1970,1969,1969,1967,1967,1998,1976,1976,1981,1994,1994,1982,1987,1987,1987,1996,1996,1983,1974,1974,1991,1991,1982,1984,1984,2004,1982,1982,1983,2009,2009,1995,1991,1991,2001,2000,2000,1991,1999,1999,2002,1988,1988,1999,1999,1979,2006,2006,2005,1983,1983,1995,1986,1986,1992,2010,2010,1993,2000,2000,1994,1994,1990,2012,2012,1989,1993,1993,1993,1986,1986,1999,1986,1986,2002,1995,1995,1995,1993,1993,2000,2000,1996,1997,1997,1995,1998,1998,1983,1997,1997,1998,1990,1990,1993,1996,1996,1982,1995,1995,2003,2003,2003,1996,1996,1993,1989,1989,2007,2008,2008,2006,2004,2004,1997,2000,2000,2012,2007,2007,2013,2013,2010,2004,2004,2010,2011,2011,2011,2015,2015,2015,2016,2016,2011,2005,2005,2014,2014,2008,1998,1998,2021,2009,2009,2007,2018];
    const [xAxisStripLinesArray, setxAxisStripLinesArray] = useState([]);
    const [yAxisStripLinesArray, setyAxisStripLinesArray] = useState([]);
    const [dps, setdps] = useState([]);
    const [dps1, setdps1] = useState([]);

    useEffect(() => {
        var xAxisStripLinesArray = [];
        var yAxisStripLinesArray = [];
        var dps = [];
        var dps1 = [];
        //dataPoints
        for(var i=0; i<dataPointsArray.length;i++){
            dps.push({y: dataPointsArray[i]});
            dps1.push({y: null});
        }
          //StripLines
        for(var i=0;i<3000;i=i+100){
          if(i%1000 != 0)
              yAxisStripLinesArray.push({value:i,thickness:0.7, color:"#DC74A5"});
        }
        for(var i=0;i<1400;i=i+20){
          if(i%200 != 0)
              xAxisStripLinesArray.push({value:i,thickness:0.7, color:"#DC74A5"});
        }
        setxAxisStripLinesArray(xAxisStripLinesArray);
        setyAxisStripLinesArray(yAxisStripLinesArray);
        setdps(dps);
        setdps1(dps1);
    }, [])

    const options = {
        title:{
      	text:"ECG Report",
      },
      subtitles:[{
          text: "Patient Name: Patient Name",
          horizontalAlign: "left",
        },
        {
          text: "Age: X-Years",
          horizontalAlign: "left",
        },
         {
          text: "Doctor Sign",
          horizontalAlign: "right",
          verticalAlign: "bottom",
        },
			],
			axisY: {
			    stripLines:yAxisStripLinesArray,
                gridThickness: 2,
                gridColor:"#DC74A5",
                lineColor:"#DC74A5",
                tickColor:"#DC74A5",
                labelFontColor:"#DC74A5"
			},
			axisX: {
			    stripLines:xAxisStripLinesArray,
                gridThickness: 2,
                gridColor:"#DC74A5",
                lineColor:"#DC74A5",
                tickColor:"#DC74A5",
                labelFontColor:"#DC74A5"
			},
			data: [{
				type: "spline",
                color: "black",
				dataPoints: dps
			},
            {
				type: "spline",
                color: "black",
				dataPoints: dps1
			}
            ]
		}
    return (
		<div>
			<h1>React Line Chart</h1>
			<CanvasJSChart options = {options}
				/* onRef={ref => this.chart = ref} */
			/>
			{/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
		</div>
		);
}

const TestBasicCanvas = (props) => {

    //
    var canvas;
    var ctx;

    // parameters for CTG paper
    const xOffset = props.position ? props.position.xOffset : 50;
    const yOffset = props.position ? props.position.yOffset : 50;
    const boxSize = 20;
    const heartRateMin = 30;
    const heartRateMax = 240;
    const heartRateStep = 10;
    const timeStep = 30;
    var counter = 0;
    const HEARTRATE_FREQ = 4
    const MIN_TO_SEC = 60
    const NUM_HR_SAMPLES_EACH_MIN = HEARTRATE_FREQ*MIN_TO_SEC
    // heart rate data state
    const heartRate = props.heartRate
    const mHRIn = props.heartRate.mHR;
    const fHRIn = props.heartRate.fHR;
    // const [mHR, setmHR] = useState([]);
    // const [fHR, setfHR] = useState([]);
    const [currDispLength, setCurrDispLength] = useState(0)
    const updateDispLength = mHRIn.length

    const mHR = props.heartRate.mHR
    const fHR = props.heartRate.fHR

    // console.log('TestBasicCanvas: mHRIn = ', mHRIn)
    // console.log('TestBasicCanvas: fHRIn = ', fHRIn)
    // console.log('updateDispLength - currDispLength >= NUM_HR_SAMPLES_EACH_MIN', updateDispLength - currDispLength >= NUM_HR_SAMPLES_EACH_MIN)
    // if(updateDispLength - currDispLength >= NUM_HR_SAMPLES_EACH_MIN){
    //     setmHR([...mHRIn.slice(0, mHRIn.length - NUM_HR_SAMPLES_EACH_MIN + 1)])
    //     setfHR([...fHRIn.slice(0, fHRIn.length - NUM_HR_SAMPLES_EACH_MIN + 1)])
    //     console.log('TestBasicCanvas: mHR = ', mHR)
    //     console.log('TestBasicCanvas: fHR = ', fHR)
    //     // debugger
    // }

    var mBuffer = [];
    var fBuffer = [];

    //
    let interval = useRef();

    // function to create CTG paper
    const createCTGPaper = (ctx) => {
        // const numMinute = (Math.ceil(props.heartRate.fHR.length / (5*4*60)) + 1) * 5 ;
        const numMinute = 60
        const numHorizontalLine = (heartRateMax-heartRateMin)/heartRateStep;
        const numVerticalLine = numMinute*2;

        var background = new Image();
        background.src = LogoCanvas;

        background.onload = function(){
            ctx.drawImage(background, 620, 550, 202*2, 24*2);
        }

        // Paths
        ctx.strokeStyle = "black"
        ctx.fillStyle = "red";
        ctx.lineWidth = 0.1;
        // bpm horizontal line
        for (var i = 0; i < numHorizontalLine+1; i++){
            ctx.beginPath();
            ctx.moveTo(xOffset, yOffset+boxSize*i);
            ctx.lineTo(xOffset+boxSize*numVerticalLine, yOffset+boxSize*i);
            ctx.stroke();
        }
        // minute line
        for (var i = 0; i < numVerticalLine+1; i++){
            ctx.beginPath();
            ctx.moveTo(xOffset+boxSize*i, yOffset);
            ctx.lineTo(xOffset+boxSize*i, yOffset+numHorizontalLine*boxSize);
            ctx.stroke();
        }
        // mark 5 minutes
        ctx.fillStyle = "rgba(50, 50, 168, 0.1)";
        for (var i = 0; i < numMinute/5; i++){
            ctx.fillRect(xOffset+20*10*i, yOffset, 20, numHorizontalLine*boxSize);
        }
         // mark 5 minutes
        ctx.font = "15px Arial";
        ctx.fillStyle = "red";
        for (var i = 0; i < numMinute/5+1; i++){
            ctx.fillText((i*5).toString(), xOffset+20*10*i, 20+yOffset+numHorizontalLine*boxSize);
        }
        // mark bpm stick
        ctx.fillStyle = "rgba(67, 153, 28, 0.2)";
        ctx.fillRect(xOffset-30, yOffset, 30, numHorizontalLine*boxSize);
        // mark 10bpm stick spacing
        ctx.font = "15px Arial";
        ctx.fillStyle = "red";
        for(var i = 0; i < 5; i++){
            ctx.fillText((30 + i*50).toString(), xOffset-30, yOffset+numHorizontalLine*boxSize-i*5*20);
            ctx.stroke();
        }

        //draw a new yAxis after every 10 minutes
        [10, 20, 30, 40, 50, 60].forEach(minute => {
            ctx.font = "15px Arial";
            ctx.fillStyle = "red";
            for(var i = 0; i < 5; i++){
                ctx.fillText((30 + i*50).toString(), 40*minute + yOffset, yOffset+numHorizontalLine*boxSize-i*5*20);
                ctx.stroke();
            }
        })

        // mart time stick
        ctx.fillStyle = "rgba(67, 153, 28, 0.2)";
        ctx.fillRect(xOffset, yOffset+numHorizontalLine*boxSize, boxSize*numVerticalLine, 30);

        // mark id and date time
        let datetime = new Date();
        ctx.fillStyle = "black"
        ctx.fillText(datetime.toString(), xOffset, yOffset+numHorizontalLine*boxSize+45)
    }

    // function to plot heart rate
    const plotHeartRate = (ctx) => {
        const numMinute = (Math.ceil(fHR.length / (5*4*60)) + 1) * 5 ;
        const numHorizontalLine = (heartRateMax-heartRateMin)/heartRateStep;
        const numVerticalLine = numMinute*2;
        ctx.strokeStyle = "blue";
        ctx.lineWidth = 1;
        ctx.beginPath();
        for (var i = 0; i < fHR.length - 1; i++){
            let currentX = (i*0.25*boxSize)/(timeStep);
            let currentY = ((fHR[i]-30)*boxSize)/heartRateStep;
            let nextX = ((i+1)*0.25*boxSize)/(timeStep);
            let nextY = ((fHR[i+1]-30)*boxSize)/heartRateStep;
            if(currentY > 0 && nextY > 0){
                ctx.moveTo(xOffset+currentX,yOffset + numHorizontalLine*boxSize - currentY);
                ctx.lineTo(xOffset+nextX, yOffset + numHorizontalLine*boxSize - nextY);            
            }
        }
         ctx.stroke();
        //mHR
        ctx.beginPath();
        ctx.strokeStyle = "black";
        for (var i = 0; i < mHR.length - 1; i++){
            let currentX = (i*0.25*boxSize)/(timeStep);
            let currentY = ((mHR[i]-30)*boxSize)/heartRateStep;
            let nextX = ((i+1)*0.25*boxSize)/(timeStep);
            let nextY = ((mHR[i+1]-30)*boxSize)/heartRateStep;
            // debugger
            if(currentY > 0 && nextY > 0){
                ctx.moveTo(xOffset+currentX,yOffset + numHorizontalLine*boxSize - currentY);
                ctx.lineTo(xOffset+nextX, yOffset + numHorizontalLine*boxSize - nextY);                
            }
        }
        ctx.stroke();
    }

    // const updateHeartRate = () => {
    //     // const numMinute = (Math.ceil(fHR.length / (5*4*60)) + 1) * 5 ;
    //     // debugger
    //     const PERIOD_UPDATE_IN_SEC = 10
    //     interval = setInterval(() => {
    //         if (currDispLength< mHRIn.length) {
    //             // console.log("update heart rate", counter);
    //             setmHR([...mHRIn.slice(1, currDispLength)])
    //             setfHR([...fHRIn.slice(1, currDispLength)])
    //             setCurrDispLength(currDispLength + PERIOD_UPDATE_IN_SEC*HEARTRATE_FREQ)
    //         } else {
    //             console.log("clear timer");
    //             clearInterval(interval);
    //         }
    //     }, PERIOD_UPDATE_IN_SEC*1000)
    // }

    useEffect(() => {
       // get canvas and contextsc
        canvas = document.getElementById("canvas");
        ctx = canvas.getContext("2d");
        // TODO: scale for device screen size
        ctx.translate(0.5, 0.5);
        // create CTG paper
        createCTGPaper(ctx);
    }, [])

    useEffect(() => {
        canvas = document.getElementById("canvas");
        ctx = canvas.getContext("2d");
        plotHeartRate(ctx);
    }, [mHR, fHR])


    // useEffect(() => {
    //     updateHeartRate();
    // },[])

    return (
        <canvas id="canvas" width={window.innerWidth * 2} height={window.innerHeight*2}>
            Canvas
        </canvas>
    )
}

const UACanvas = (props) => {

    //
    var canvas;
    var ctx;
    console.log('UACanvas props: ')
    console.log(props)

    // parameters for CTG paper
    const xOffset = props.position ? props.position.xOffset : 50;
    const yOffset = props.position ? props.position.yOffset : 50;
    const boxSize = 20;
    const heartRateMin = 0;
    const heartRateMax = 100;
    const heartRateStep = 10;
    const timeStep = 30;
    var counter = 0;
    const HEARTRATE_FREQ = 4
    const MIN_TO_SEC = 60
    const NUM_HR_SAMPLES_EACH_MIN = HEARTRATE_FREQ*MIN_TO_SEC
    // heart rate data state
    const heartRate = props.heartRate
    const mHRIn = props.heartRate.mHR;
    const fHRIn = props.heartRate.fHR;
    // const [mHR, setmHR] = useState([]);
    // const [fHR, setfHR] = useState([]);
    const [currDispLength, setCurrDispLength] = useState(0)
    const updateDispLength = mHRIn.length

    const mHR = props.heartRate.mHR
    const fHR = props.heartRate.fHR

    // console.log('TestBasicCanvas: mHRIn = ', mHRIn)
    // console.log('TestBasicCanvas: fHRIn = ', fHRIn)
    // console.log('updateDispLength - currDispLength >= NUM_HR_SAMPLES_EACH_MIN', updateDispLength - currDispLength >= NUM_HR_SAMPLES_EACH_MIN)
    // if(updateDispLength - currDispLength >= NUM_HR_SAMPLES_EACH_MIN){
    //     setmHR([...mHRIn.slice(0, mHRIn.length - NUM_HR_SAMPLES_EACH_MIN + 1)])
    //     setfHR([...fHRIn.slice(0, fHRIn.length - NUM_HR_SAMPLES_EACH_MIN + 1)])
    //     console.log('TestBasicCanvas: mHR = ', mHR)
    //     console.log('TestBasicCanvas: fHR = ', fHR)
    //     // debugger
    // }

    var mBuffer = [];
    var fBuffer = [];

    //
    let interval = useRef();

    // function to create CTG paper
    const createCTGPaper = (ctx) => {
        // const numMinute = (Math.ceil(props.heartRate.fHR.length / (5*4*60)) + 1) * 5 ;
        const numMinute = 60
        const numHorizontalLine = (heartRateMax-heartRateMin)/heartRateStep;
        const numVerticalLine = numMinute*2;

        var background = new Image();
        background.src = LogoCanvas;

        background.onload = function(){
            ctx.drawImage(background, 620, 550, 202*2, 24*2);
        }

        // Paths
        ctx.strokeStyle = "black"
        ctx.fillStyle = "red";
        ctx.lineWidth = 0.1;
        // bpm horizontal line
        for (var i = 0; i < numHorizontalLine+1; i++){
            ctx.beginPath();
            ctx.moveTo(xOffset, yOffset+boxSize*i);
            ctx.lineTo(xOffset+boxSize*numVerticalLine, yOffset+boxSize*i);
            ctx.stroke();
        }
        // minute line
        for (var i = 0; i < numVerticalLine+1; i++){
            ctx.beginPath();
            ctx.moveTo(xOffset+boxSize*i, yOffset);
            ctx.lineTo(xOffset+boxSize*i, yOffset+numHorizontalLine*boxSize);
            ctx.stroke();
        }
        // mark 5 minutes
        ctx.fillStyle = "rgba(50, 50, 168, 0.1)";
        for (var i = 0; i < numMinute/5; i++){
            ctx.fillRect(xOffset+20*10*i, yOffset, 20, numHorizontalLine*boxSize);
        }
         // mark 5 minutes
        ctx.font = "15px Arial";
        ctx.fillStyle = "red";
        for (var i = 0; i < numMinute/5+1; i++){
            ctx.fillText((i*5).toString(), xOffset+20*10*i, 20+yOffset+numHorizontalLine*boxSize);
        }
        // mark bpm stick
        ctx.fillStyle = "rgba(67, 153, 28, 0.2)";
        ctx.fillRect(xOffset-30, yOffset, 30, numHorizontalLine*boxSize);
        // mark 10bpm stick spacing
        ctx.font = "15px Arial";
        ctx.fillStyle = "red";
        for(var i = 0; i < 5; i++){
            ctx.fillText((0 + i*20).toString(), xOffset, yOffset+numHorizontalLine*boxSize-i*10*4);
            ctx.stroke();
        }

        //draw a new yAxis after every 10 minutes
        [10, 20, 30, 40, 50, 60].forEach(minute => {
            ctx.font = "15px Arial";
            ctx.fillStyle = "red";
            for(var i = 0; i < 5; i++){
                ctx.fillText((0 + i*20).toString(), 10*4*minute +xOffset, yOffset+numHorizontalLine*boxSize-i*10*4);
                ctx.stroke();
            }
        })

        // mart time stick
        ctx.fillStyle = "rgba(67, 153, 28, 0.2)";
        ctx.fillRect(xOffset, yOffset+numHorizontalLine*boxSize, boxSize*numVerticalLine, 30);

        // mark id and date time
        let datetime = new Date();
        ctx.fillStyle = "black"
        ctx.fillText(datetime.toString(), xOffset, yOffset+numHorizontalLine*boxSize+45)
    }

    // function to plot heart rate
    const plotHeartRate = (ctx) => {
        const numMinute = (Math.ceil(fHR.length / (5*4*60)) + 1) * 5 ;
        const numHorizontalLine = (heartRateMax-heartRateMin)/heartRateStep;
        const numVerticalLine = numMinute*2;
        ctx.strokeStyle = "blue";
        ctx.lineWidth = 1;
        ctx.beginPath();
        for (var i = 0; i < fHR.length - 1; i++){
            let currentX = (i*0.25*boxSize)/(timeStep);
            let currentY = ((fHR[i])*boxSize)/heartRateStep;
            let nextX = ((i+1)*0.25*boxSize)/(timeStep);
            let nextY = ((fHR[i+1])*boxSize)/heartRateStep;
            if(currentY > 0 && nextY > 0){
                ctx.moveTo(xOffset+currentX,yOffset + numHorizontalLine*boxSize - currentY);
                ctx.lineTo(xOffset+nextX, yOffset + numHorizontalLine*boxSize - nextY);            
            }
        }
         ctx.stroke();
        //mHR
        // ctx.beginPath();
        // ctx.strokeStyle = "black";
        // for (var i = 0; i < mHR.length - 1; i++){
        //     let currentX = (i*0.25*boxSize)/(timeStep);
        //     let currentY = ((mHR[i]-30)*boxSize)/heartRateStep;
        //     let nextX = ((i+1)*0.25*boxSize)/(timeStep);
        //     let nextY = ((mHR[i+1]-30)*boxSize)/heartRateStep;
        //     // debugger
        //     if(currentY > 0 && nextY > 0){
        //         ctx.moveTo(xOffset+currentX,yOffset + numHorizontalLine*boxSize - currentY);
        //         ctx.lineTo(xOffset+nextX, yOffset + numHorizontalLine*boxSize - nextY);                
        //     }
        // }
        // ctx.stroke();
    }

    // const updateHeartRate = () => {
    //     // const numMinute = (Math.ceil(fHR.length / (5*4*60)) + 1) * 5 ;
    //     // debugger
    //     const PERIOD_UPDATE_IN_SEC = 10
    //     interval = setInterval(() => {
    //         if (currDispLength< mHRIn.length) {
    //             // console.log("update heart rate", counter);
    //             setmHR([...mHRIn.slice(1, currDispLength)])
    //             setfHR([...fHRIn.slice(1, currDispLength)])
    //             setCurrDispLength(currDispLength + PERIOD_UPDATE_IN_SEC*HEARTRATE_FREQ)
    //         } else {
    //             console.log("clear timer");
    //             clearInterval(interval);
    //         }
    //     }, PERIOD_UPDATE_IN_SEC*1000)
    // }

    useEffect(() => {
       // get canvas and contextsc
        canvas = document.getElementById("canvas");
        ctx = canvas.getContext("2d");
        // TODO: scale for device screen size
        ctx.translate(0.5, 0.5);
        // create CTG paper
        createCTGPaper(ctx);
    }, [])

    useEffect(() => {
        canvas = document.getElementById("canvas");
        ctx = canvas.getContext("2d");
        const numHorizontalLine = (heartRateMax-heartRateMin)/heartRateStep;
        const numVerticalLine = 60*2;
        const numMinute = (Math.ceil(fHR.length / (5*4*60)) + 1) * 5  
           
        ctx.clearRect(xOffset, yOffset, numVerticalLine*boxSize, numHorizontalLine*boxSize)
        ctx.strokeStyle = "black"
        ctx.fillStyle = "red";
        ctx.lineWidth = 0.1;
        // bpm horizontal line
        for (var i = 0; i < numHorizontalLine+1; i++){
            ctx.beginPath();
            ctx.moveTo(xOffset, yOffset+boxSize*i);
            ctx.lineTo(xOffset+boxSize*numVerticalLine, yOffset+boxSize*i);
            ctx.stroke();
        }
        // minute line
        for (var i = 0; i < numVerticalLine+1; i++){
            ctx.beginPath();
            ctx.moveTo(xOffset+boxSize*i, yOffset);
            ctx.lineTo(xOffset+boxSize*i, yOffset+numHorizontalLine*boxSize);
            ctx.stroke();
        }
        // mark 5 minutes
        ctx.fillStyle = "rgba(50, 50, 168, 0.1)";
        for (var i = 0; i < numMinute/5; i++){
            ctx.fillRect(xOffset+20*10*i, yOffset, 20, numHorizontalLine*boxSize);
        }
         // mark 5 minutes
        ctx.font = "15px Arial";
        ctx.fillStyle = "red";
        for (var i = 0; i < numMinute/5+1; i++){
            ctx.fillText((i*5).toString(), xOffset+20*10*i, 20+yOffset+numHorizontalLine*boxSize);
        }
        // // mark bpm stick
        // ctx.fillStyle = "rgba(67, 153, 28, 0.2)";
        // ctx.fillRect(xOffset-30, yOffset, 30, numHorizontalLine*boxSize);
        // mark 10bpm stick spacing
        ctx.font = "15px Arial";
        ctx.fillStyle = "red";
        for(var i = 0; i < 5; i++){
            ctx.fillText((0 + i*20).toString(), xOffset, yOffset+numHorizontalLine*boxSize-i*10*4);
            ctx.stroke();
        }

        //draw a new yAxis after every 10 minutes
        [10, 20, 30, 40, 50, 60].forEach(minute => {
            ctx.font = "15px Arial";
            ctx.fillStyle = "red";
            for(var i = 0; i < 5; i++){
                ctx.fillText((0 + i*20).toString(), 10*4*minute +xOffset, yOffset+numHorizontalLine*boxSize-i*10*4);
                ctx.stroke();
            }
        })

        // mart time stick
        // ctx.fillStyle = "rgba(67, 153, 28, 0.2)";
        // ctx.fillRect(xOffset, yOffset+numHorizontalLine*boxSize, boxSize*numVerticalLine, 30);

        plotHeartRate(ctx);
    }, [mHR, fHR])


    // useEffect(() => {
    //     updateHeartRate();
    // },[])

    return (
        <canvas id="canvasUA" width={window.innerWidth * 2} height={window.innerHeight*2}>
            Canvas
        </canvas>
    )
}

const MultiCTGView = (props) => {
    const useStyles = makeStyles((theme) => ({
        root: {
            flexGrow: 1,
            overflow: "auto"
        }
    }));
    console.log('MultiCTGView props')
    console.log(props)
    const classes = useStyles();
    return (
       <div className={classes.root} style={{height: 2000}}>
            <TestBasicCanvas heartRate={props.heartRate} position={{xOffset: 50, yOffset: 50}}></TestBasicCanvas>
            <UACanvas heartRate={props.yUA} position={{xOffset: 50, yOffset: 550}}></UACanvas>
       </div>
    )
}


const TestScrollCanvas = () => {
    const [mHR, setmHR] = useState([]);
    const [counter, setcounter] = useState(0);
    var mycounter = 0;

    let interval = useRef();
    const updateData = () => {
         interval = setInterval(() => {
            console.log("counter ", mycounter);
            mycounter = mycounter + 1;
            setcounter(mycounter);
            setmHR([1,2,3]);

            if (mycounter > 10){
            console.log("clear timer");
            clearInterval(interval);
            }
        }, 1000)


    }
    // var myupdate = updateData();

    useEffect(() => {
        updateData();
    }, []);

    return(
        <h1>
            Scroll Canvas {mHR} and counter {counter}
        </h1>
    )
}

export default MultiCTGView
